import {
    BarGradient,
    Box,
    buildLinearGradient,
    IconButton,
    InfoIcon,
    Typography,
    useTheme,
    Tooltip
} from '@methanesat/ui-components';
import { ColorScales } from '../../../consts';
import { useTranslate } from '../../../hooks';
import { MethaneLayerIds } from '../../../types';
import { getBarGradientWidth } from './MiniLegendUtils';

interface DispersedEmissionsTooltipProps {
    colorScales: ColorScales;
}

export const DispersedEmissionsTooltip = ({ colorScales }: DispersedEmissionsTooltipProps) => {
    const theme = useTheme();
    const t = useTranslate();

    const tooltipContent = (
        <>
            <Box marginBottom={1}>
                <Typography variant="body1" fontWeight={theme.typography.fontWeightBold}>
                    {t(`emissionsMapPage.miniLegend.${MethaneLayerIds.areaEmissionRaster}.l4TooltipTitle`)}
                </Typography>
            </Box>

            {Object.keys(colorScales).map((scale) => {
                const { colors } = colorScales[scale];
                const colorArray = colors.map((c) => c.color);
                const gradientString = buildLinearGradient(colorArray);

                return (
                    <Box key={scale} display="flex" flexDirection="row" gap={1} marginBottom={1}>
                        <Box width={'20%'} display="flex" flexDirection="column">
                            <Typography
                                variant="caption"
                                fontWeight={theme.typography.fontWeightBold}
                                sx={{ lineHeight: '0.75rem' }}
                            >
                                {t(
                                    `emissionsMapPage.miniLegend.${MethaneLayerIds.areaEmissionRaster}.l4ColorScales.${scale}.title`
                                )}
                            </Typography>
                            <Box width={getBarGradientWidth(scale)}>
                                <BarGradient gradientString={gradientString} height="3px" marginTop="5px" />
                            </Box>
                        </Box>
                        <Box width={'80%'}>
                            <Typography variant="caption" sx={{ lineHeight: '0.75rem' }}>
                                {t(
                                    `emissionsMapPage.miniLegend.${MethaneLayerIds.areaEmissionRaster}.l4ColorScales.${scale}.description`
                                )}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </>
    );

    return (
        <Tooltip enterTouchDelay={0} leaveTouchDelay={3000} title={tooltipContent}>
            <IconButton
                size="small"
                data-testid="dispersed-emissions-tooltip-close"
                sx={{ color: 'inherit', padding: '0px', marginLeft: '4px', alignSelf: 'flex-start', paddingTop: 2 }}
            >
                <InfoIcon
                    sx={{
                        fontSize: '20px'
                    }}
                />
            </IconButton>
        </Tooltip>
    );
};
